module.exports = __webpack_public_path__ + "img/hat-img_1.4ba3be02.png";